import React, { useState, useEffect, useRef } from "react";
import {
  ARROWS_DISTANCE,
  CIRCLE_SIZE,
  LINE_COLOR,
  LINE_START,
  LINE_WIDTH,
  MAX_DISTANCE,
  PODIUM_SCALE,
  RESIZE_MODEL,
  ROTATE_FLOORS,
  ROTATE_MODEL,
  SHOW_INITIAL_ANIMATION,
  TRANSPARENCY,
  X,
  Z,
} from "../../constants";
import Input from "./Input";
import { getCurrentViewData } from "../../utils/threeJsUtils";

const ApartmentSettings = ({ apartment, saveViewData, camera }) => {
  // console.log("ApartmentSettings", apartment.default_view.views);
  const [views, setViews] = useState([]);

  const addView = () => {
    setViews([...views, { viewName: "New View", viewData: getCurrentViewData(camera) }]);
  };
  const saveView = (viewName) => {
    const viewData = getCurrentViewData(camera);
    if (apartment.default_view.views) {
      apartment.default_view.views.push({
        viewName,
        viewData,
      });
    } else {
      apartment.default_view.views = [
        {
          viewName,
          viewData,
        },
      ];
    }
    setViews(apartment.default_view.views);
    saveViewData("app_view", apartment.default_view)
  }

  const deleteView = (viewName) => {
    if (apartment.default_view.views) {
      apartment.default_view.views = apartment.default_view.views.filter(view => view.viewName !== viewName);
    }
    setViews(apartment.default_view.views);
    saveViewData("app_view", apartment.default_view)
  }
  const View = ({ view }) => {
    const [viewName, setViewName] = useState(view.viewName);

    return (
      <div className="d-flex">
        <input
          style={{
            // width: "50px",
            textAlign: "center",
          }}
          value={viewName}
          // onBlur={(e) =>
          //   onChange({
          //     label,
          //     value: e.target.value,
          //   })
          // }
          onChange={(e) => setViewName(e.target.value,)}
        />
        <button onClick={() => saveView(viewName)}>Save</button>
        <button onClick={() => deleteView(viewName)}>Delete</button>
      </div>
    );
  };
  console.log("views", views);
  return (
    <div className="p-2">
      <h3>Apartment settings</h3>
      <button onClick={() => saveViewData("app")}>Save apartment view</button>
      <button onClick={() => addView()}>Add View</button>
      {views.map((view, index) => {
        return <View key={index} view={view} />;
      })}
    </div>
  );
};

export default ApartmentSettings;
